import { render } from "./UIScrollTopBtn.vue?vue&type=template&id=0db5e971"
import script from "./UIScrollTopBtn.vue?vue&type=script&lang=js"
export * from "./UIScrollTopBtn.vue?vue&type=script&lang=js"

import exportComponent from "D:\\work\\vue-workspace\\fe-registry\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__